import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {COMMON_CONSTANT} from '../../config/constants/common-keys.constants';
import {ConsultantSearchFilter, JobPayload, JobSummary} from '../../../interfaces/talentPoolInterface';
import {Consultant} from '../../../interfaces/consultantInterfact';
import {ApiResponse} from '../../../interfaces/apiResponseInterface';
import {JobDetail} from '../../../interfaces/jobInterface';
import {WorkTimeZone} from '../../../components/work-time-zone/work-time-zone.component';

@Injectable({
  providedIn: 'root',
})

export class TalentPoolService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  }

  constructor(private _http: HttpClient) {
  }

  getConsultants(page: number, size: number, payload: Partial<ConsultantSearchFilter> | {}) {
    return this._http.post<ApiResponse<Consultant>>(`${COMMON_CONSTANT.API_BASE_URL}/consultant/search`, payload || {}, {
      params: {
        page: page,
        size: size,
      }
    });
  }

  getConsultant(consultantId: string) {
    return this._http.get<Consultant>(`${COMMON_CONSTANT.API_BASE_URL}/consultant/${consultantId}`, this.httpOptions);
  }

  getJobSummary() {
    return this._http.get<JobSummary[]>(`${COMMON_CONSTANT.API_BASE_URL}/customer/job-summary`, this.httpOptions);
  }

  getJobDetail(jobId: string) {
    return this._http.get<JobDetail>(`${COMMON_CONSTANT.API_BASE_URL}/jobs/${jobId}`, this.httpOptions);
  }

  getTimeZones() {
    return this._http.get<WorkTimeZone[]>(`${COMMON_CONSTANT.API_BASE_URL}/time-zones`, this.httpOptions)
  }

  addConsultantToMyList(contactId: string,payload:JobPayload) {
    return this._http.post<JobPayload>(`${COMMON_CONSTANT.API_BASE_URL}/customer/contact/${contactId}/consultant/mylist`,payload, this.httpOptions)
  }

  addInterested(consultantId: string) {
    return this._http.post(`${COMMON_CONSTANT.API_BASE_URL}/consultant/${consultantId}/favourite`, {});
  }

  removeInterested(consultantId: string) {
    return this._http.delete(`${COMMON_CONSTANT.API_BASE_URL}/consultant/${consultantId}/favourite`);
  }

}
